// Explicit imports keep every independently authored page discoverable in the build.
module.exports = {
  'ai-strategy-consulting': require('./ai-strategy-consulting'),
  'ai-readiness-assessment': require('./ai-readiness-assessment'),
  'ai-training-workshops': require('./ai-training-workshops'),
  'executive-ai-enablement': require('./executive-ai-enablement'),
  'ai-transformation': require('./ai-transformation'),
  'ai-product-development': require('./ai-product-development'),
  'custom-ai-development': require('./custom-ai-development'),
  'ai-integration': require('./ai-integration'),
  'enterprise-ai': require('./enterprise-ai'),
  'legacy-modernization': require('./legacy-modernization'),
  'data-engineering': require('./data-engineering'),
  'ai-engineering-teams': require('./ai-engineering-teams'),
  'generative-ai': require('./generative-ai'),
  'agentic-ai': require('./agentic-ai'),
  'knowledge-retrieval': require('./knowledge-retrieval'),
  'machine-learning': require('./machine-learning'),
  'computer-vision': require('./computer-vision'),
  'speech-audio-ai': require('./speech-audio-ai'),
  'document-intelligence': require('./document-intelligence'),
  'decision-intelligence': require('./decision-intelligence'),
  'mlops': require('./mlops'),
  'ai-managed-services': require('./ai-managed-services'),
  'ai-governance': require('./ai-governance'),
  'ai-security': require('./ai-security'),
};
